import styled from "styled-components";
import {GameJackpotBarAmountDefaultBox} from "./game-jackpot-bar-amount.default.box";

export const GameJackpotBarAmountCasino888Box = styled(GameJackpotBarAmountDefaultBox)<{isOptInStatus?: boolean}>`
    background: linear-gradient(180deg, #FFE600 17.85%, #FCD303 87.26%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
`;